if (!customElements.get('product-savings-bar')) {
  customElements.define('product-savings-bar', class ProductSavingsBar extends HTMLElement {
    constructor() {
      super();
      this.handleUserInteraction = this.handleUserInteraction.bind(this);
      this.updateComponentState = this.updateComponentState.bind(this);
      this.formIdentifier = this.dataset.formId;
      this.debounceTimer = null;
    }

    connectedCallback() {
      document.addEventListener('click', this.handleUserInteraction);
      this.updateComponentState();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleUserInteraction);
    }

    handleUserInteraction(event) {
      const targetElement = event?.target;
      const isBundleRadio = targetElement?.hasAttribute('data-bundle-radio');
      const isUpsellCheckbox = targetElement?.hasAttribute('data-bundle-checkbox');

      if (isBundleRadio || isUpsellCheckbox) {
        this.applyDebounce(this.updateComponentState, 50);
      }
    }

    applyDebounce(callbackFunction, delayTime) {
      window.clearTimeout(this.debounceTimer);
      this.debounceTimer = window.setTimeout(() => {
        callbackFunction();
      }, delayTime);
    }

    updateComponentState() {
      const activeBundleSelector = `[data-bundle-radio][form="${this.formIdentifier}"]:checked`;
      const activeBundleElement = document.querySelector(activeBundleSelector);

      if (!activeBundleElement) return;

      const quantity = parseInt(activeBundleElement?.value ?? 1);
      const bundlePriceCents = parseInt(activeBundleElement?.dataset?.price ?? 0);
      const bundleRegularPriceCents = parseInt(activeBundleElement?.dataset?.regularPrice ?? bundlePriceCents);
      const bundleDiscountPercentage = parseInt(activeBundleElement?.dataset?.discount ?? 0);

      let accumulatedRegularPrice = bundleRegularPriceCents * quantity;
      let accumulatedFinalPrice = (bundlePriceCents * quantity) * (1 - (bundleDiscountPercentage / 100));

      const selectedUpsellElements = document.querySelectorAll('[data-bundle-checkbox]:checked');

      selectedUpsellElements?.forEach((upsellElement) => {
        const upsellPriceCents = parseInt(upsellElement?.dataset?.price ?? 0);
        const upsellRegularPriceCents = parseInt(upsellElement?.dataset?.regularPrice ?? upsellPriceCents);

        accumulatedRegularPrice += upsellRegularPriceCents;
        accumulatedFinalPrice += upsellPriceCents;
      });

      const totalSavingsAmount = accumulatedRegularPrice - accumulatedFinalPrice;

      this.renderUpdatedValues(accumulatedFinalPrice, totalSavingsAmount);
    }

    renderUpdatedValues(totalFinalAmount, totalSavingsAmount) {
      const totalPriceElement = this.querySelector('[data-total-price]');
      const totalSavingsElement = this.querySelector('[data-total-savings]');

      if (totalPriceElement) {
        totalPriceElement.textContent = this.formatCurrency(totalFinalAmount);
      }

      if (totalSavingsElement) {
        totalSavingsElement.textContent = this.formatCurrency(totalSavingsAmount);
      }

      this.style.setProperty('--savings-percentage', `${(totalSavingsAmount / (totalFinalAmount + totalSavingsAmount)) * 100}%`);
    }

    formatCurrency(amountInCents) {
      if (window?.Shopify?.formatMoney) {
        return Shopify.formatMoney(amountInCents, window?.theme?.moneyFormat ?? "${{amount}}");
      }
      return `$${(amountInCents / 100).toFixed(2)}`;
    }
  });
}